import { type core, z } from "zod";

const missingValueCodes = new Set(["invalid_type", "invalid_value", "custom"]);

export const friendlyZodMessage = (issue: core.$ZodRawIssue): string | undefined => {
    if (missingValueCodes.has(issue.code) && (issue.input === undefined || issue.input === null)) {
        return "Required";
    }

    if (issue.code === "too_small" && issue.origin === "string") {
        if (issue.exact) {
            return `Must be exactly ${issue.minimum} characters`;
        }

        return Number(issue.minimum) <= 1
            ? "Required"
            : `Must be at least ${issue.minimum} characters`;
    }

    if (issue.code === "too_big" && issue.origin === "string") {
        if (issue.exact) {
            return `Must be exactly ${issue.maximum} characters`;
        }

        return `Must be ${issue.maximum} characters or fewer`;
    }

    return undefined;
};

z.config({
    jitless: true,
    customError: friendlyZodMessage,
});
